<template>
  <header>
    <nav class="d-flex align-items-center justify-content-center">
      <router-link to="/" class="tab m-1 p-1">Home</router-link>
      <router-link to="/about" class="tab m-1 p-1">About</router-link>
    </nav>
  </header>
</template>
